module.exports = __webpack_public_path__ + "static/media/logo.3718a15e.png";